import wrapError from "@/components/helpers/wrapError"

export const apiUpdateSendgridApiKey = (success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/internal/sendgridApiKey",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    success,
    error: wrapError(error, "apiUpdateSendgridApiKey"),
  })
}
